import { IButtonElement } from "@faire/web-api--source/indigofair/data/IButtonElement";
import { ButtonVariants } from "@faire/web/slate/Button";

const DEFAULT_BUTTON_VARIANT = "primary";

export const getSlateButtonVariant = (
  buttonVariant: keyof typeof IButtonElement.ButtonVariant | undefined
): ButtonVariants => {
  if (buttonVariant === undefined) {
    return DEFAULT_BUTTON_VARIANT;
  }
  return buttonVariantToSlateTokenMap[buttonVariant];
};

const buttonVariantToSlateTokenMap: Record<
  IButtonElement.ButtonVariant,
  ButtonVariants
> = {
  [IButtonElement.ButtonVariant.PRIMARY]: "primary",
  [IButtonElement.ButtonVariant.SECONDARY]: "secondary",
  [IButtonElement.ButtonVariant.TERTIARY]: "tertiary",
  [IButtonElement.ButtonVariant.BUTTON_VARIANT_UNKNOWN]: DEFAULT_BUTTON_VARIANT,
};
